import { useEffect, useRef, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import axios from 'axios';
import { url } from '../../../env';
import { downloadPDF } from '../functions/downloadPDF';
import { Footer, Header } from '../../../Components';
import { generateBudgetPDFCSS } from './GenerateBudgetPDF.css';
import { peicarLogo2, peicarLogoSVG } from '../../../Assets/Images';
import { GenericHeader } from '../../../Components/GenericHeader/GenericHeader';
import { set } from 'react-hook-form';
import { PDFViewer } from '@react-pdf/renderer';
import { PDFComponent } from '../PDFComponent/PDFComponent';

export default function GenerateBudgetPDF() {

    const urlParams = useParams();

    const [loading, setLoading] = useState(false);
    const firstRender = useRef(true);

    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const id = params.get("id");

    const [data, setData] = useState();


    const generatePDF = async () => {

        setLoading(true);

        try {
            const { data } = await axios({
                method: 'get',
                url: `${url}/generateBudgetPDF`,
                params: {
                    id: id,
                    secret: urlParams.secret
                }
            })
            setData(data);
            downloadPDF(data.resumen, data.detalle, data.pdfPlazo);


        } catch (error) {
            console.log(error);
        }

        setLoading(false);

    }

    useEffect(() => {
        if (firstRender.current) {
            generatePDF()
            firstRender.current = false;
        }
        else
            return;
    }, [urlParams.secret]);

    return (
        <div css={generateBudgetPDFCSS}>
            
            <GenericHeader />
            {
                loading ? (
                    <section>
                        <p>Estamos descargando tu cotización.</p>
                        <p>Espera un poco más...</p>
                        <div className='image'>
                            <span>
                                <img src={peicarLogo2} alt='logo' />
                            </span>
                        </div>
                    </section>
                ) : (
                    <section>
                        <p>Tu cotización se ha descargado con éxito.</p>
                    </section>
                )
            }
            <Footer />

        </div>
    );
}